import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2022年度重庆责任企业巡礼暨年度典型案例征集';
const baseUrl = '20221021CQZRQY';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeTwo',
      name: `${baseUrl}-homeTwo`,
      component: () => import('./pages/HomeTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeThree',
      name: `${baseUrl}-HomeThree`,
      component: () => import('./pages/HomeThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'homeDetail',
      name: `${baseUrl}-homeDetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
